import { ControlEventType } from '../../controls/enums';

export const FormControlState = {
  Value: 'value',
  Error: 'error',
  IsValid: 'isValid',
  IsDisabled: 'isDisabled',
  ValidationStrategy: 'validationStrategy',
};

export const FormGroupState = {
  Controls: 'controls',
  Error: 'error',
  IsDisabled: 'isDisabled',
};

export const FormControlValidationStrategy = {
  ...ControlEventType,
};

export default {
  FormControlState,
};
